import { render, staticRenderFns } from "./lead.vue?vue&type=template&id=1c34b371&scoped=true&"
import script from "./lead.vue?vue&type=script&lang=js&"
export * from "./lead.vue?vue&type=script&lang=js&"
import style0 from "./lead.vue?vue&type=style&index=0&id=1c34b371&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c34b371",
  null
  
)

export default component.exports